exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-ed851c0e] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n[data-v-ed851c0e] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n[data-v-ed851c0e] .el-dialog__body {\n  padding-bottom: 5px;\n}\n.input-common[data-v-ed851c0e] {\n  margin-right: 5px;\n}\n.el-row[data-v-ed851c0e] {\n  margin-bottom: 5px;\n  font-size: 17px;\n  color: white;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n}\n.el-col[data-v-ed851c0e] {\n  padding: 9px 5px;\n}\n", ""]);

// exports
